// codes
export const UNAUTHORIZED_STATUS_CODE = 401;
export const NOT_FOUND_STATUS_CODE = 404;
export const ACCESS_DENIED_STATUS_CODE = 403;
export const NO_CONTENT_STATUS_CODE = 204;

// auth
export const API_CODE_TOKEN_INVALID = 'auth.token_invalid';
export const API_CODE_TOKEN_REVOKED = 'auth.token_revoked';
export const API_CODE_CREDENTIALS_MISSING = 'auth.credentials_missing';
export const API_CODE_CREDENTIALS_INCORRECT = 'auth.credentials_incorrect';
export const API_CODE_INACTIVE_USER = 'auth.inactive_user';
export const API_CODE_AUTH_FAILED = 'auth.failed';
export const API_CODE_TOO_MANY_ATTEMPTS = 'auth.too_many_attempts';
export const API_CODE_DELETION_IS_REQUESTED = 'auth.deletion_is_requested';

// assets
export const API_CODE_CONTENT_TYPE_IS_NOT_SUPPORTED = 'assets.content_type_is_not_supported';
export const API_CODE_INCORRECT_FILE_SIZE = 'assets.incorrect_file_size"';
export const API_CODE_DURATION_EXCEEDS_MAX = 'assets.duration_exceeds_max';

// deliverables
export const API_CODE_FB_DATA_ENABLING_NOT_SUPPORTED = 'deliverable.fb_data_enabling_is_not_supported';
export const API_CODE_TASK_CONTAINS_BINDING_OUTFITS = 'deliverable.task_contains_binding_outfits';

// campaigns
export const API_CODE_NO_ZALANDO_BRANDS_FOR_TRACKING_LINK = 'campaign.no_zalando_brands_for_tracking_links';

// profiles
export const API_CODE_NO_PROFILE_IDENTIFIER_FOUND = 'influencer_profile.profile_identifier_not_found';

// outfits
export const API_CODE_ACTION_NOT_ALLOWED_FOR_ZALANDO_OUTFIT = 'outfits.action_not_allowed_for_zalando_outfit';

// ccm campaign metadata
export const CCM_METADATA_OUTFITS_NOT_PUBLISHED = 'ccm_external_metadata.outfits_not_published';
export const CCM_METADATA_WRONG_CREATIVE_KIND = 'ccm_external_metadata.wrong_creative_kind';
export const CCM_METADATA_OUTFITS_NOT_MAPPED = 'ccm_external_metadata.outfits_not_mapped';
export const CCM_METADATA_CREATIVES_NOT_MAPPED = 'ccm_external_metadata.creatives_not_mapped';
export const CCM_METADATA_INCOMPLETE_OUTFIT_REPRESENTATION = 'ccm_external_metadata.incomplete_outfit_representation';
